angular.module('picmonicng').directive('stopPropagation', function () {
  return {
    restrict: 'A',
    link: function (scope, elem, attrs) {
      elem.click(function (e) {
        e.stopPropagation();
      });
    },
  };
});
